




































































import {
  defineComponent,
  ref,
  computed,
  onMounted,
  Ref,
  useRouter,
} from "@nuxtjs/composition-api";
import { useFAQ } from "~/modules/pageExten/composables/useFAQ";
import type {
  FaqQuestion,
  FaqResult,
  FaqGroupResult,
  UseFAQErrors,
} from "~/modules/pageExten/composables/useFAQ/useFAQ";
import { magento } from "~/config/extensionsApi";
import FaqSearch from "~/modules/pageExten/components/FaqSearch.vue";
import HeaderAccountMobile from "~/components/Header/HeaderAccountMobile.vue";

export default defineComponent({
  name: "FaqPage",
  components: {
    FaqSearch,
    HeaderAccountMobile
  },
  setup() {
    // Import the useFAQ composable
    const {
      questions,
      faqGroups,
      loading,
      error,
      fetchQuestion,
      searchQuestions,
      getFaqGroupList,
    } = useFAQ();
    // Router instance
    const router = useRouter();

    // Component state
    // Component state
    const searchTerm = ref<string>("");
    const searchResults = ref<FaqResult | null>(null);
    const activeQuestions = ref<Record<string, boolean>>({});
    const mediaUrl = (url) => {
      return `${magento.media_url}/${url}`;
    };
    // Computed properties to simplify template
    const questionsList = computed((): FaqQuestion[] => {
      if (!questions.value || !questions.value.items) {
        return [];
      }
      return questions.value.items;
    });

    const hasNoQuestions = computed((): boolean => {
      return questionsList.value.length === 0;
    });

    // Computed property to filter and sort active FAQ groups
    const activeFaqGroups = computed(() => {
      if (!faqGroups.value || !faqGroups.value.items) {
        return [];
      }

      return faqGroups.value.items
        .filter((group) => group.status === "1")
        .sort((a, b) => parseInt(a.sort_order) - parseInt(b.sort_order));
    });

    // Functions that handle active state
    const isQuestionActive = (id: string | number): boolean => {
      const stringId = String(id);
      return Boolean(activeQuestions.value[stringId]);
    };

    const toggleQuestion = (id: string | number): void => {
      const stringId = String(id);
      // Create a new object to ensure Vue detects the change
      activeQuestions.value = {
        ...activeQuestions.value,
        [stringId]: !activeQuestions.value[stringId],
      };
    };

    const handleSearch = async (): Promise<void> => {
      const term = searchTerm.value.trim();
      if (term !== "") {
        // Redirect to the detail page with search term
        router.push({
          path: '/hoi-dap/tim-kiem',
          query: { q: term }
        });
      }
    };

    onMounted(async () => {
      // Optional search criteria for FAQ groups
      const questionSearchCriteria = {
        "searchCriteria[pageSize]": 5,
        "searchCriteria[currentPage]": 1,
        // Add other criteria as needed
      };

      await getFaqGroupList();
      await fetchQuestion(questionSearchCriteria);
    });

    return {
      searchTerm,
      searchResults,
      loading,
      error,
      questionsList,
      hasNoQuestions,
      isQuestionActive,
      toggleQuestion,
      handleSearch,
      activeQuestions,
      faqGroups,
      activeFaqGroups,
      mediaUrl,
    };
  },
});
